var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey;

var captchaIDs = {};
function hCaptchaOnLoad () {
    $('.h-captcha').each(function () {
        var form = $(this).closest('form');
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "size": "invisible",
            "callback": function (token) {
                $('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    });
}
$(document).ready(function() {
    
    $( ".ir-sidebar" ).click(function() {
      $( '.glyphicon-menu-down' ).toggleClass( "glyphicon-menu-up" );
    });
    
    $(".ir-sidebar").focusout(function(){
        $( '.glyphicon' ).removeClass( "glyphicon-menu-up" );
    });
    
    $('.mobile-nav-trigger').click(function(){
        $('.main-nav').css('height', 'auto');
    });
    
    //Set Cursor pointer to anything with data-toggle
    $("*[data-toggle]").css( 'cursor', 'pointer' );
    
    $('header.affixed').affix({
        offset:{
            top: 1
        }
    });
    
    //Circle Stat with Percentage Animation
    var divPercentage = $('.stats-row-w-percents');
    if(divPercentage.length) {
        $(document).bind('scroll', function(ev) {
            var scrollOffset = $(document).scrollTop();
            var containerOffset = $('.stats-row-w-percents').offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                $('.stats-row-w-percents .stat').each(function() {
                    var percDiv = $(this).find('.number'),
                    svgElm = $(this).find('.circle'),
                    percentNumber = $(this).attr('data-percent');
                    svgElm.attr('stroke-dasharray', percentNumber + ', 100');
                    svgElm.addClass('active');
                    $({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + '%');
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                $(document).unbind('scroll');
            }
        });
    }
    
    var subNav = $('.sub-navigation.affixed');
    if(subNav.length) {
        $(subNav).affix({
            offset: { 
                top: $(".sub-navigation").offset().top - $("header").outerHeight()
            }
        });
    }

    var menuRight = document.getElementById( 'mobile-nav' ),
    showRight = document.getElementById( 'showRight' ),
    body = document.body;
    
    if (showRight) {
        showRight.onclick = function() {
            $(this).toggleClass("active");
            $('body').toggleClass('push-to-left');
            $(menuRight).toggleClass("cbp-spmenu-open");
            disableOther( 'showRight' );
            toggleMenuKeybind();
        };
    }
    function disableOther( button ) {
        if( button !== 'showRight' ) {
          $(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
    
     function toggleMenuKeybind() {
        var $body = $('body'),
            $body_events = $body.data("events");
            
        if ($body_events != null && typeof($body_events.keydown) != undefined) {
            $body.off('keydown');
        }else {
        $body.on('keydown', function(e) {
            if (e.which == 27) {
                $('.main-nav').toggleClass("active");
                $('body').toggleClass('push-to-left');
                $(menuRight).toggleClass("cbp-spmenu-open");
                disableOther( 'showRight' );
                $body.off('keydown');
            }
        });
        }
    }

    // Basic Form Validation
    var validator = $(".validate-form");
    
    validator.each( function() {
        var $form = $(this);
        var formID = $form.attr('id');
        $(this).validate({
            errorPlacement: function(error, element) {
                error.appendTo( element.parent() );
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            }
        });
    });
    
    $.validator.methods.email = function( value, element ) {
      return this.optional( element ) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test( value );
    }
    
    $('.toggle-button').click(function() {
        $(this).toggleClass("open");
    });
    
    $('.fancybox').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '600'
    });
    
    $('.fancybox-bio').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '0'
    });
    
    $('.fancybox-modal').fancybox({
        width: 970,
        autoSize: false,
        height: 'auto'
    });
    
    //File input
    var fileInput = $('.file-text input');
    fileInput.change(function(e){
        $this = $(this);
        var val = $this.val().split('\\');
        var length = val.length;
        var filename = val[length-1];
        $(this).parent('.file-text').children('.text-wrapper').text(filename);
    });

    // SEC Filing Filters - auto submit form
    $('#sec-filing-filter select').on('change', function(e) {
        $(this).closest('form').submit(); 
    });


});

// Quote Box
function populateQuoteBox(quote) {

    if ($('.ir-quote-box').length > 0) {
        var quoteContainer = $('.ir-quote-box[data-symbol="' + quote.symbol + '"]');
    } else {
        var quoteContainer = $('.quote-box[data-symbol="' + quote.symbol + '"]');
        var home_change = true;
    }
        
    var quote_price = checkQuoteProperty(quote.last),
        quote_change = checkQuoteProperty(quote.change),
        quote_change_pct = checkQuoteProperty(quote.change_pct),
        quote_high = checkQuoteProperty(quote.high),
        quote_low = checkQuoteProperty(quote.low),
        quote_day_low = checkQuoteProperty(quote.day_low),
        quote_day_high = checkQuoteProperty(quote.day_high),
        quote_volume = quote.volume;
        // Quotemedia's volume already comes back formatted, so we do not need to custom format it
        if (quote_volume && quote.use_quotemedia !== true) {
            quote_volume = quote_volume.replace(/\,/g,'');
            quote_volume = parseInt(quote_volume,10);
            quote_volume = abbrNum(quote_volume, 2);
        }   
   

    quoteContainer.find('.time').html('<time />');
    quoteContainer.find('time').attr('datetime', quote.last_trade_time).html(quote.last_trade_time);  
    
    
    if (quote_price == 'N/A') {
        quoteContainer.find('.price .value').html('N/A');
    } else {
          quoteContainer.find('.price .value').html('$' + quote_price);
    }

    if (quote.market_cap == 'N/A') {
        quoteContainer.find('.market-cap .value').html('N/A');
    } else {
        quoteContainer.find('.market-cap .value').html('$' + quote.market_cap);
    }
    
     if (quote.volume == null) {
         quoteContainer.find('.volume .value').html('N/A');
     }else {
         quoteContainer.find('.volume .value').html(quote_volume);
     }

    var change = quote_change.replace(/[+|-]/g, '');

    
    quoteContainer.find('.change .value .number').html(change);
    
    if(quote_change_pct != '0.00' && quote_change_pct != 'N/A' && quote_change_pct != '0' ) {
        quoteContainer.find('.change .value .percent').html('(' + quote_change_pct + '%)');
    }
    if (home_change) {
        quoteContainer.find('.change .home-change-value').html(change);
    }

    if (quote.change.indexOf('+') > -1 && change !== '0' && change !== '0.00') {
        quoteContainer.find('.change').addClass('up');
    } else if (quote.change.indexOf('-') > -1) {
        quoteContainer.find('.change').addClass('down');
    }
    
    if (quote.low == quote.high) {
        week = quote_low;    
    } else {
        var week = quote_low + ' - ' + quote_high;         
    }
    quoteContainer.find('.week-range .value').html(week);

    if (quote.day_low != 'N/A' && quote.day_high != 'N/A') {
        if (quote.day_low == quote.day_high) {
            var day = quote_day_low;
        } else {
            day = quote_day_low + ' - ' + quote_day_high;
        }
        quoteContainer.find('.day-range .value').html(day);
    } else {
        quoteContainer.find('.day-range .value').html(quote.last)
    }
    
    $('.jsrange').jsRange({
        dayLow: quote_day_low,
        dayHigh: quote_day_high,
        yearLow: quote_low,
        yearHigh: quote_high
    });

}

// SEC Filings expand
$(".spr-expandable").hide();
$(".spr-toggle-expandable").click(function() {
	$(this).next(".spr-expandable").toggle("blind");
});

// Equal Heights
$(window).load(function () {
    checkWidth();
});

function checkQuoteProperty(value) {
    return (value != "N/A") ? parseFloat(value).toFixed(2) : value;
}

function abbrNum(number, decPlaces) {
    var orig = number;
    var dec = decPlaces;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);

    // Enumerate number abbreviations
    var abbrev = ["K", "M", "B", "T"];

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {

        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);

        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;

            // Handle special case where we round up to the next abbreviation
            if ((number == 1000) && (i < abbrev.length - 1)) {
                number = 1;
                i++;
            }

            // console.log(number);
            // Add the letter for the abbreviation
            number += abbrev[i];

            // We are done... stop
            break;
        }
    }

    //console.log('abbrNum('+ orig + ', ' + dec + ') = ' + number);
    return number;
}

// Add commas to numbers
$.fn.digits = function() {
    return this.each(function() {
        $(this).text($(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    });
};

//Smooth scroll to
function goToByScroll(id) {
    $('html,body').animate({
        scrollTop: $(id).offset().top
    }, 'slow');
}
$('.smooth').click(function() {
    goToByScroll($(this).attr('href'));
    return false;
});

//Check Width
var resizeTimer;
$(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkWidth, 250);
});

function checkWidth() {
    if ($(window).width() > 767) {
        $('.js-same-height, .js-same-height-row').each(function() {
            $(this).addClass('active');
        });
        sameHeight();
    } else {
        $('.js-same-height, .js-same-height-row').each(function() {
            $(this).removeClass('active');
        });
        $(".js-same-height,.js-same-height-row .js-height").css('min-height', '').css('height', '');
    }
    if ($(window).width() < 769) {
        $('.fancybox').each(function() {
            $(this).addClass('fancybox-holder').removeClass('fancybox');
        });
        $('.thickbox').each(function() {
            $(this).addClass('thickbox-holder').removeClass('thickbox');
        });
    } else {
        $('.fancybox-holder').each(function() {
            $(this).addClass('fancybox').removeClass('fancybox-holder');
        });
        $('.thickbox-holder').each(function() {
            $(this).addClass('thickbox').removeClass('thickbox-holder');
        });
    }

}

// Same Height
function sameHeight() {
    $(".js-same-height-row").each(function() {
        var $maxHeight = 0,
            $window_width = $(window).width();
        $('.js-same-height', this).css({
            'height': 'auto',
            'min-height': 0
        });
        if (($(this).data('cutoff') && $(this).data('cutoff') >= $window_width) || $window_width < 768) {
            return false;
        }
        $('.js-same-height', this).each(function() {
            if ($(this).outerHeight() > $maxHeight) {
                $maxHeight = $(this).outerHeight();
            }
        }).css('min-height', $maxHeight);
        $('.js-height', this).css({
            'height': $maxHeight,
            'min-height': 0
        });
    });
}

// Fixes XBRL Filing Close Button click event being unbound by an early call to tb_remove
$(document).ajaxComplete(function() {
    $('#TB_closeAjaxWindow #TB_closeWindowButton').on('mousedown', function() {
        tb_remove();
    });
});

// Checkbox Groups
var update_sec_checkboxes = function() {
    if ($('#ir-sec-all').is(':checked')) {
        $(".ir-sec-sub").prop('checked', true).prop('disabled', true);
    } else {
        $(".ir-sec-sub").prop('disabled', false).prop('checked', false);
    }
}
$('#ir-sec-all').change(update_sec_checkboxes);
if ($('#ir-sec-all').is(':checked')) {
    $(".ir-sec-sub").prop('checked', true).prop('disabled', true);
}
